<template>
  <v-text-field v-bind="$props" v-on="$listeners"
    :readonly="adminUnlocked"
    :append-icon="adminUnlocked ? mdiLock : mdiLockOpen"
    @click:append="adminUnlocked = !adminUnlocked"
  >
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
      @input="onInput"
    >
      <slot :name="slot" v-bind="scope" />
    </template>
  </v-text-field>
</template>

<script>
import { mdiLock, mdiLockOpen } from '@mdi/js';
import { VTextField } from 'vuetify/lib';

export default {
  name: 'AdminOverrideField',
  extends: VTextField,
  data() {
    return {
      /**
      * icons.
      */
      mdiLock,
      mdiLockOpen,
      /**
      * local variables.
      */
      adminUnlocked: true,
    };
  },
};
</script>
